import store from '~/store'

class PlatformHelper {
    static all() {
        return store.getters['platforms/all'];
    }

    static get(id) {
        return _.find(this.all(), {id: +id});
    }

    static has(id) {
        return this.get(id) !== undefined;
    }
}

export default PlatformHelper;
